import createUser from "./createUser";

const createUserSilently = async (email: string, password: string) => {
  try {
    const res = await createUser(email, password);
    return res;
  } catch (error) {
    // Log the error instead of throwing it
    console.error(error);
  }
};

export default createUserSilently;
